import { messages as companies } from "./companies/de";
import { messages as co2Database } from "./co2-database/de";
import { messages as esgRatings } from "./esg-ratings/de";
import { messages as sco2pesFinancial } from "./sco2pes-financial/de";
import { messages as esgRiskAnalyses } from "./esg-risk-analyses/de";
import { messages as survey } from "./survey/de";
import { messages as users } from "./users/de";
import { messages as esgSelfAssessment } from "./esg-self-assessment/de";
import { messages as units } from "./units/de";
import { messages as integration } from "./integration/de";
import { messages as distanceCalc } from "./distance-calc/de";
import { messages as news } from "./news/de";
import { messages as sso } from "./sso/de";


export const messages = {
  ...companies,
  ...co2Database,
  ...esgRatings,
  ...esgRiskAnalyses,
  ...sco2pesFinancial,
  ...survey,
  ...users,
  ...esgSelfAssessment,
  ...units,
  ...integration,
  ...distanceCalc,
  ...news,
  ...sso,
};
